'use strict';

function input() {
  return {
    require: '?ngModel',
    priority: 1,
    restrict: 'E',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      // make sure autocomplete trigger events
      if (attr.type !== 'file' && attr.type !== 'checkbox' && attr.type !== 'radio') {
        el.on('blur', () => {
          scope.$apply(() => {
            ctrl.$setViewValue(el.val());
          });
        });
      }

      if (ctrl.$validators.email) {
        // email
        ctrl.$validators.email = (value) => {
          return ctrl.$isEmpty(value) || /[a-zA-Z0-9!#$%&+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/.test(value);
        };
      }
    }
  };
}

function mobileNumberValidator() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      function validate() {
        let value = ctrl.$viewValue;

        if (ctrl.$isEmpty(value) || /^(?:4[015-8]|9\d)\d{6}$/.test(value)) {
          ctrl.$setValidity('mobileNumber', true);
        } else {
          ctrl.$setValidity('mobileNumber', false);
        }
      }

      // watch own value and re-validate on change
      scope.$watch(attr.ngModel, () => {
        validate();
      });

      // observe the other value and re-validate on change
      attr.$observe('mobileNumber', () => {
        validate();
      });
    }
  };
}

function internationalMobileNumberValidator() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      function validate() {
        let value = ctrl.$viewValue;

        if (ctrl.$isEmpty(value) || /^[\+]?[0-9\s]+$/.test(value)) {
          ctrl.$setValidity('mobileNumber', true);
        } else {
          ctrl.$setValidity('mobileNumber', false);
        }
      }

      // watch own value and re-validate on change
      scope.$watch(attr.ngModel, () => {
        validate();
      });

      // observe the other value and re-validate on change
      attr.$observe('mobileNumber', () => {
        validate();
      });
    }
  };
}

function organisationNumberValidator($http, $q) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      ctrl.$asyncValidators.organisationNumber = (modelValue, viewValue) => {
        let defer = $q.defer();

        if (viewValue && viewValue !== null && viewValue !== '') {
          let val = viewValue.replace(/[^0-9.]/g, '');

          if (val.length !== 9) {
            defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 123456789 eller 123 456 789');
          } else {
            $http.get(`/common/public/organisationNumber/${val}`)
              .then(() => defer.resolve())
              .catch((err) => defer.reject(err.data.endUserMessage));
          }
        } else {
          defer.resolve();
        }

        return defer.promise;
      };
    }
  };
}

function birthNumberValidator($http, $q) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      ctrl.$asyncValidators.birthNumber = (modelValue, viewValue) => {
        let defer = $q.defer();

        if (viewValue && viewValue !== null && viewValue !== '') {
          let val = viewValue.replace(/[^0-9.]/g, '');
          if (val.length !== 11) {
            defer.reject('Vennligst fyll inn et gyldig fødselsnummer.');
          } else {
            $http.get(`/common/public/birthNumber/${val}`)
              .then(() => defer.resolve())
              .catch((err) => defer.reject(err.data.endUserMessage));
          }
        } else {
          defer.resolve();
        }

        return defer.promise;
      };
    }
  };
}


function recipientOrganisationNumberValidator($http, $q) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      ctrl.$asyncValidators.organisationNumber = (modelValue, viewValue) => {
        let defer = $q.defer();

        let icd = scope.$ctrl.recipient && scope.$ctrl.recipient.organisation ? scope.$ctrl.recipient.organisation.icd : '9908';

        if (viewValue && viewValue !== null && viewValue !== '') {
          // validate swedish
          if (icd === '0007') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{6}[-]\\d{4})|(\\d{10})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 1234567890 eller 123456-7890');
            }
            // validate GLN
          } else if (icd === '0088') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{13})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig GLN-nummer. Et gyldig GLN-nummer består av 13 sifre');
            }
            // validate norwegian
          } else {
            let val = viewValue.replace(/[^0-9.]/g, '');

            if (val.length !== 9) {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 123456789 eller 123 456 789');
            } else {
              $http.get(`/common/public/organisationNumber/${val}`)
                .then(() => defer.resolve())
                .catch((err) => defer.reject(err.data.endUserMessage));
            }
          }
        } else {
          defer.resolve();
        }

        return defer.promise;
      };
    }
  };
}

function sendPageRecipientOrganisationNumberValidator($http, $q) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      ctrl.$asyncValidators.organisationNumber = (modelValue, viewValue) => {
        let defer = $q.defer();

        let icd = scope.$ctrl.invoice.recipient.icd ? scope.$ctrl.invoice.recipient.icd : '9908';

        if (viewValue && viewValue !== null && viewValue !== '') {
          // validate swedish
          if (icd === '0007') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{6}[-]\\d{4})|(\\d{10})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 1234567890 eller 123456-7890');
            }
            // validate norwegian
          } else if (icd === '0088') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{13})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig GLN-nummer. Et gyldig GLN-nummer består av 13 sifre');
            }
            // validate norwegian
          } else {
            let val = viewValue.replace(/[^0-9.]/g, '');

            if (val.length !== 9) {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 123456789 eller 123 456 789');
            } else {
              $http.get(`/common/public/organisationNumber/${val}`)
                .then(() => defer.resolve())
                .catch((err) => defer.reject(err.data.endUserMessage));
            }
          }
        } else {
          defer.resolve();
        }

        return defer.promise;
      };
    }
  };
}

function dunningSendPageRecipientOrganisationNumberValidator($http, $q) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      ctrl.$asyncValidators.organisationNumber = (modelValue, viewValue) => {
        let defer = $q.defer();

        let icd = scope.$ctrl.dunning.recipient.icd ? scope.$ctrl.dunning.recipient.icd : '9908';

        if (viewValue && viewValue !== null && viewValue !== '') {
          // validate swedish
          if (icd === '0007') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{6}[-]\\d{4})|(\\d{10})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 1234567890 eller 123456-7890');
            }
            // validate norwegian
          } else if (icd === '0088') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{13})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig GLN-nummer. Et gyldig GLN-nummer består av 13 sifre');
            }
            // validate norwegian
          } else {
            let val = viewValue.replace(/[^0-9.]/g, '');

            if (val.length !== 9) {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 123456789 eller 123 456 789');
            } else {
              $http.get(`/common/public/organisationNumber/${val}`)
                .then(() => defer.resolve())
                .catch((err) => defer.reject(err.data.endUserMessage));
            }
          }
        } else {
          defer.resolve();
        }

        return defer.promise;
      };
    }
  };
}

function eventRecipientOrganisationNumberValidator($http, $q) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      ctrl.$asyncValidators.organisationNumber = (modelValue, viewValue) => {
        let defer = $q.defer();

        //somehow it's read twice ane there's an error it's undefined first time
        let icd = (undefined === scope.$ctrl.participant.invoice) ? '9908' : scope.$ctrl.participant.invoice.icd;

        if (viewValue && viewValue !== null && viewValue !== '') {
          // validate swedish
          if (icd === '0007') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{6}[-]\\d{4})|(\\d{10})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 1234567890 eller 123456-7890');
            }
            // validate norwegian
          } else if (icd === '0088') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{13})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig GLN-nummer. Et gyldig GLN-nummer består av 13 sifre');
            }
            // validate norwegian
          } else {
            let val = viewValue.replace(/[^0-9.]/g, '');

            if (val.length !== 9) {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 123456789 eller 123 456 789');
            } else {
              $http.get(`/common/public/organisationNumber/${val}`)
                .then(() => defer.resolve())
                .catch((err) => defer.reject(err.data.endUserMessage));
            }
          }
        } else {
          defer.resolve();
        }

        return defer.promise;
      };
    }
  };
}

function participantOrganisationNumberValidator($http, $q) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, el, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      ctrl.$asyncValidators.organisationNumber = (modelValue, viewValue) => {
        let defer = $q.defer();

        let icd = scope.vm.eventInvoice.invoice.icd;

        if (viewValue && viewValue !== null && viewValue !== '') {
          // validate swedish
          if (icd === '0007') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{6}[-]\\d{4})|(\\d{10})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  $('.alert-box.system').remove();
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 1234567890 eller 123456-7890');
            }
            // validate norwegian
          } else if (icd === '0088') {
            let val = viewValue;
            let pattern = new RegExp('^(\\d{13})$');
            if (pattern.test(val)) {
              $http.get(`/common/public/organisationNumber/${icd}/${val}`)
                .then(() => {
                  defer.resolve();
                })
                .catch((err) => {
                  defer.reject(err.data.endUserMessage);
                });
            } else {
              defer.reject('Vennligst fyll inn et gyldig GLN-nummer. Et gyldig GLN-nummer består av 13 sifre');
            }
            // validate norwegian
          } else {
            let val = viewValue.replace(/[^0-9.]/g, '');

            if (val.length !== 9) {
              defer.reject('Vennligst fyll inn et gyldig organisasjonsnummer. Et organisasjonsnummer har disse gyldige formatene: 123456789 eller 123 456 789');
            } else {
              $http.get(`/common/public/organisationNumber/${val}`)
                .then(() => {
                  $('.alert-box.system').remove();
                  defer.resolve();
                })
                .catch((err) => defer.reject(err.data.endUserMessage));
            }
          }
        } else {
          $('.alert-box.system').remove();
          defer.resolve();
        }

        return defer.promise;
      };
    }
  };
}

function passwordValidator(userService) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, element, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      let username = null;

      userService.get()
        .then((resp) => {
          if (resp.data && resp.data.userName) {
            username = resp.data.userName.split('@')[0];
          }
        });

      function check(regexp, str) {
        let count = 0;

        for (let i = 0; i < str.length; i++) {
          if (regexp.test(str.charAt(i))) {
            count++;
          }
        }

        return count;
      }

      function icon(state) {
        return state ? '<i class="fa fa-times" style="color: red; width: 25px;"></i>' : '<i class="fa fa-check" style="color: green; width: 25px;"></i>';
      }

      function validate() {
        let val = ctrl.$viewValue;
        let message = '';
        let styles = 'position: absolute; width: 81%; background: var(--bkg-color); font-size: 0.9em; padding: 10px; border: 1px solid #ddd; z-index: 9999; margin-top: -10px;';

        if (val || val === '') {
          if (val.length < 8 || check(/[A-Z]/, val) < 1 || check(/[a-z]/, val) < 1 || check(/[0-9]/, val) < 1) {
            // less then 8
            message += icon(val.length < 8) + ' Minst &aring;tte tegn<br>';

            // no UPPERCASE
            message += icon(check(/[A-ZÅØÆ]/, val) < 1) + ' Ha minst &eacute;n stor bokstav<br>';

            // no lowercase
            message += icon(check(/[a-zåøæ]/, val) < 1) + ' Ha minst &eacute;n liten bokstav<br>';

            // no digit
            message += icon(check(/[0-9]/, val) < 1) + ' Minst ett tall<br>';

            // can't be the username
            message += icon(val.indexOf(username) !== -1) + ' Kan ikke inneholde brukernavnet ditt';

            element.parent().find('.password-validator').remove();
            element.parent().append(`<div class="password-validator" style="${styles}">${message}</div>`);
            ctrl.$setValidity('password-validator', false);
          } else {
            element.parent().find('.password-validator').remove();
            ctrl.$setValidity('password-validator', true);
          }
        }
      }

      // watch own value and re-validate on change
      scope.$watch(attr.ngModel, () => {
        validate();
      });

      // observe the other value and re-validate on change
      attr.$observe('password-validator', () => {
        validate();
      });
    }
  };
}

function passwordValidatorRegister() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: (scope, element, attr, ctrl) => {
      if (!ctrl) {
        return;
      }

      function check(regexp, str) {
        let count = 0;

        for (let i = 0; i < str.length; i++) {
          if (regexp.test(str.charAt(i))) {
            count++;
          }
        }

        return count;
      }

      function icon(state) {
        return state ? '<i class="fa fa-times" style="color: red; width: 25px;"></i>' : '<i class="fa fa-check" style="color: green; width: 25px;"></i>';
      }

      function validate() {
        let val = ctrl.$viewValue;
        let message = '';
        let styles = 'position: absolute; width: 81%; background: #fff; font-size: 0.9em; padding: 10px; border: 1px solid #ddd; z-index: 9999; margin-top: -10px;';

        if (val || val === '') {
          if (val.length < 8 || check(/[A-Z]/, val) < 1 || check(/[a-z]/, val) < 1 || check(/[0-9]/, val) < 1) {
            // less then 8
            message += icon(val.length < 8) + ' Minst &aring;tte tegn<br>';

            // no UPPERCASE
            message += icon(check(/[A-ZÅØÆ]/, val) < 1) + ' Ha minst &eacute;n stor bokstav<br>';

            // no lowercase
            message += icon(check(/[a-zåøæ]/, val) < 1) + ' Ha minst &eacute;n liten bokstav<br>';

            // no digit
            message += icon(check(/[0-9]/, val) < 1) + ' Minst ett tall<br>';

            element.parent().find('.password-validator').remove();
            element.parent().append(`<div class="password-validator" style="${styles}">${message}</div>`);
            ctrl.$setValidity('password-validator', false);
          } else {
            element.parent().find('.password-validator').remove();
            ctrl.$setValidity('password-validator', true);
          }
        }
      }

      // watch own value and re-validate on change
      scope.$watch(attr.ngModel, () => {
        validate();
      });

      // observe the other value and re-validate on change
      attr.$observe('password-validator', () => {
        validate();
      });
    }
  };
}

birthNumberValidator.$inject = ['$http', '$q'];
organisationNumberValidator.$inject = ['$http', '$q'];
recipientOrganisationNumberValidator.$inject = ['$http', '$q'];
sendPageRecipientOrganisationNumberValidator.$inject = ['$http', '$q'];
dunningSendPageRecipientOrganisationNumberValidator.$inject = ['$http', '$q'];
participantOrganisationNumberValidator.$inject = ['$http', '$q'];
eventRecipientOrganisationNumberValidator.$inject = ['$http', '$q'];
passwordValidator.$inject = ['userService'];

angular
  .module('sr.validators', [])
  .directive('input', input)
  .directive('internationalMobileNumberValidator', internationalMobileNumberValidator)
  .directive('mobileNumberValidator', mobileNumberValidator)
  .directive('birthNumberValidator', birthNumberValidator)
  .directive('organisationNumberValidator', organisationNumberValidator)
  .directive('recipientOrganisationNumberValidator', recipientOrganisationNumberValidator)
  .directive('sendPageRecipientOrganisationNumberValidator', sendPageRecipientOrganisationNumberValidator)
  .directive('dunningSendPageRecipientOrganisationNumberValidator', dunningSendPageRecipientOrganisationNumberValidator)
  .directive('participantOrganisationNumberValidator', participantOrganisationNumberValidator)
  .directive('eventRecipientOrganisationNumberValidator', eventRecipientOrganisationNumberValidator)
  .directive('passwordValidator', passwordValidator)
  .directive('passwordValidatorRegister', passwordValidatorRegister);
